import { PowerUpType } from "../../data/enums";
import { PowerUpBase } from "./PowerUpBase";

export class GasCanPowerUp extends PowerUpBase {
    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y, "powerup-gas", PowerUpType.GasCan, 20000);
    }
}
